import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';
import { LicenseEmptyState, LicenseHintKind } from './LicenseHint';

/** Zeigt `children` nur mit gebuchtem Modul, sonst den Buchungshinweis (z. B. die Routen der Epochenplanung). */
export const RequireModule = observer(
  ({ enabled, hint, children }: { enabled: 'epochen'; hint: LicenseHintKind; children: ReactNode }) => {
    const permissions = usePermissionChecker();
    const licensed = enabled === 'epochen' ? permissions?.isEpochenEnabled() : true;
    return licensed ? children : <LicenseEmptyState hint={hint} />;
  },
);
